module.exports = __webpack_public_path__ + "static/media/eyecam-co.39eaebdf.svg";